import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/testimonials';

const TestimonialsSection = () => {
  return (
    <section
      data-testid="testimonials-section"
      style={{
        background: 'var(--bg-section)',
        padding: '5rem 0'
      }}
    >
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            Ce que les personnes accompagnées disent
          </h2>
          <p
            className="body-large"
            style={{
              color: 'var(--text-muted)',
              maxWidth: '640px',
              margin: '0 auto'
            }}
          >
            Des accompagnements sur-mesure, des transformations durables.
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.75rem',
            maxWidth: '1200px',
            margin: '0 auto'
          }}
        >
          {testimonials.map((t) => (
            <article
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              style={{
                background: 'white',
                borderRadius: '1rem',
                padding: '2rem',
                border: '1px solid var(--border-light)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                display: 'flex',
                flexDirection: 'column',
                gap: '1.25rem',
                position: 'relative'
              }}
            >
              <Quote
                size={28}
                style={{
                  color: 'var(--accent-primary-light)',
                  opacity: 0.6,
                  position: 'absolute',
                  top: '1.25rem',
                  right: '1.25rem'
                }}
              />

              <p
                className="body-medium"
                style={{
                  color: 'var(--text-secondary)',
                  lineHeight: 1.7,
                  fontStyle: 'italic',
                  flex: 1
                }}
              >
                {`« ${t.content} »`}
              </p>

              <div
                style={{
                  borderTop: '1px solid var(--border-light)',
                  paddingTop: '1rem'
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    color: 'var(--text-primary)',
                    marginBottom: '0.25rem'
                  }}
                >
                  {t.name}
                </div>
                <div
                  className="body-small"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {`${t.location} · ${t.context}`}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
